// Washington State University's undergraduate majors (#2748). Read on
// 2026-10-01 from WSU's official Degree Finder (degrees.wsu.edu, its
// get-degrees feed and each degree profile page), which names the college
// that offers each field and the bachelor's degree it leads to, by campus.
// Kept: every field with a bachelor's option at the Pullman campus (the
// campus this page covers). Left out: fields with no Pullman bachelor's
// (Nursing's prelicensure BSN is taught in Spokane and Tri-Cities; Public
// Affairs in Vancouver; Viticulture and Enology and the standalone Business
// Administration listing at Tri-Cities and Everett), graduate and
// professional degrees, minors and certificates. The general catalog
// (catalog.wsu.edu) is a script-only app that returned no readable text, so
// the Degree Finder is the official list used. It gives no degree
// abbreviations, so `degree` is null; where a field is earned inside a
// broader bachelor's degree (e.g. Accounting in Business Administration),
// the note names it. The Degree Finder writes "Women's" with a curly
// apostrophe; it is straight here. The KB's majors list was the starting
// point; the Degree Finder wins.
const majors = {
    "slug": "washington-state-university",
    "read": "2026-10-01",
    "intro": "Every major WSU's official Degree Finder lists with a bachelor's degree at the Pullman campus, grouped by the college that offers it. Where a major is earned within a broader bachelor's degree, the note names that degree. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Carson College of Business",
            "source": {
                "label": "WSU Degree Finder, Degrees & Majors",
                "url": "https://degrees.wsu.edu/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null,
                    "note": "Bachelor's degree in Business Administration."
                },
                {
                    "name": "Aging Business Management",
                    "degree": null,
                    "note": "Bachelor's degree in Hospitality Business Management."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": null,
                    "note": "Bachelor's degree in Business Administration."
                },
                {
                    "name": "Finance",
                    "degree": null,
                    "note": "Bachelor's degree in Business Administration."
                },
                {
                    "name": "Hospitality Business Management",
                    "degree": null
                },
                {
                    "name": "International Business",
                    "degree": null,
                    "note": "Bachelor's degree in Business Administration."
                },
                {
                    "name": "Management",
                    "degree": null,
                    "note": "Bachelor's degree in Business Administration."
                },
                {
                    "name": "Management Information Systems",
                    "degree": null,
                    "note": "Bachelor's degree in Business Administration."
                },
                {
                    "name": "Marketing",
                    "degree": null,
                    "note": "Bachelor's degree in Business Administration."
                },
                {
                    "name": "Wine and Beverage Business Management",
                    "degree": null,
                    "note": "Bachelor's degree in Hospitality Business Management."
                }
            ]
        },
        {
            "name": "College of Agricultural, Human, and Natural Resource Sciences",
            "source": {
                "label": "WSU Degree Finder, Degrees & Majors",
                "url": "https://degrees.wsu.edu/"
            },
            "majors": [
                {
                    "name": "Agricultural Biotechnology",
                    "degree": null,
                    "note": "Bachelor's degree in Integrated Plant Sciences."
                },
                {
                    "name": "Agricultural Education",
                    "degree": null,
                    "note": "Bachelor's degree in Agricultural and Food Systems."
                },
                {
                    "name": "Agricultural Technology and Production Management",
                    "degree": null,
                    "note": "Bachelor's degree in Agricultural and Food Systems."
                },
                {
                    "name": "Agricultural and Food Business Economics",
                    "degree": null,
                    "note": "Bachelor's degree in Agricultural and Food Systems."
                },
                {
                    "name": "Animal Sciences",
                    "degree": null
                },
                {
                    "name": "Apparel, Merchandising, Design and Textiles",
                    "degree": null
                },
                {
                    "name": "Earth Sciences",
                    "degree": null,
                    "note": "Bachelor's degree in Earth and Environmental Sciences."
                },
                {
                    "name": "Economic Sciences",
                    "degree": null
                },
                {
                    "name": "Environmental and Ecosystem Sciences",
                    "degree": null,
                    "note": "Bachelor's degree in Earth and Environmental Sciences."
                },
                {
                    "name": "Field Crop Management",
                    "degree": null,
                    "note": "Bachelor's degree in Integrated Plant Sciences."
                },
                {
                    "name": "Food Science",
                    "degree": null
                },
                {
                    "name": "Forest Ecology and Management",
                    "degree": null,
                    "note": "Bachelor's degree in Earth and Environmental Sciences."
                },
                {
                    "name": "Fruit and Vegetable Management",
                    "degree": null,
                    "note": "Bachelor's degree in Integrated Plant Sciences."
                },
                {
                    "name": "Human Development",
                    "degree": null
                },
                {
                    "name": "Human Nutrition and Food Systems",
                    "degree": null,
                    "note": "Bachelor's degree in Agricultural and Food Systems."
                },
                {
                    "name": "Landscape, Nursery, and Greenhouse Management",
                    "degree": null,
                    "note": "Bachelor's degree in Integrated Plant Sciences."
                },
                {
                    "name": "Organic and Sustainable Agriculture",
                    "degree": null
                },
                {
                    "name": "Turfgrass Management",
                    "degree": null,
                    "note": "Bachelor's degree in Integrated Plant Sciences."
                },
                {
                    "name": "Wildlife Ecology and Conservation Sciences",
                    "degree": null,
                    "note": "Bachelor's degree in Earth and Environmental Sciences."
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "WSU Degree Finder, Degrees & Majors",
                "url": "https://degrees.wsu.edu/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Art",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese Language and Culture",
                    "degree": null,
                    "note": "Bachelor's degree in Foreign Languages and Cultures."
                },
                {
                    "name": "Comparative Ethnic Studies",
                    "degree": null
                },
                {
                    "name": "Criminal Justice and Criminology",
                    "degree": null
                },
                {
                    "name": "Data Analytics",
                    "degree": null
                },
                {
                    "name": "Digital Technology and Culture",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null,
                    "note": "Bachelor's degree in Foreign Languages and Cultures."
                },
                {
                    "name": "General Science",
                    "degree": null,
                    "note": "Bachelor's degree in General Studies."
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Human Biology",
                    "degree": null
                },
                {
                    "name": "Humanities",
                    "degree": null
                },
                {
                    "name": "Japanese",
                    "degree": null,
                    "note": "Bachelor's degree in Foreign Languages and Cultures."
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Music Business",
                    "degree": null
                },
                {
                    "name": "Music Composition",
                    "degree": null
                },
                {
                    "name": "Music Education",
                    "degree": null
                },
                {
                    "name": "Music Performance",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Social Sciences",
                    "degree": null
                },
                {
                    "name": "Social Studies",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null,
                    "note": "Bachelor's degree in Foreign Languages and Cultures."
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": null
                },
                {
                    "name": "Zoology",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Education, Sport and Human Sciences",
            "source": {
                "label": "WSU Degree Finder, Degrees & Majors",
                "url": "https://degrees.wsu.edu/"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": null
                },
                {
                    "name": "Kinesiology",
                    "degree": null
                },
                {
                    "name": "Sport Management",
                    "degree": null
                },
                {
                    "name": "Sports Medicine and Athletic Training",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Pharmacy and Pharmaceutical Sciences",
            "source": {
                "label": "WSU Degree Finder, Degrees & Majors",
                "url": "https://degrees.wsu.edu/"
            },
            "majors": [
                {
                    "name": "Pharmaceutical and Medical Sciences",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Veterinary Medicine",
            "source": {
                "label": "WSU Degree Finder, Degrees & Majors",
                "url": "https://degrees.wsu.edu/"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Genetics and Cell Biology",
                    "degree": null
                },
                {
                    "name": "Microbiology",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Public Health",
                    "degree": null
                }
            ]
        },
        {
            "name": "Edward R. Murrow College of Communication",
            "source": {
                "label": "WSU Degree Finder, Degrees & Majors",
                "url": "https://degrees.wsu.edu/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": null,
                    "note": "Bachelor's degree in Strategic Communication."
                },
                {
                    "name": "Broadcast News",
                    "degree": null,
                    "note": "Bachelor's degree in Journalism and Media Production."
                },
                {
                    "name": "Broadcast Production",
                    "degree": null,
                    "note": "Bachelor's degree in Journalism and Media Production."
                },
                {
                    "name": "Integrated Strategic Communication",
                    "degree": null,
                    "note": "Bachelor's degree in Strategic Communication."
                },
                {
                    "name": "Journalism and Media Production",
                    "degree": null
                },
                {
                    "name": "Media and Innovation",
                    "degree": null,
                    "note": "Bachelor's degree in Journalism and Media Production."
                },
                {
                    "name": "Multimedia Journalism",
                    "degree": null,
                    "note": "Bachelor's degree in Journalism and Media Production."
                },
                {
                    "name": "Public Relations",
                    "degree": null,
                    "note": "Bachelor's degree in Strategic Communication."
                },
                {
                    "name": "Risk and Crisis Communication",
                    "degree": null,
                    "note": "Bachelor's degree in Strategic Communication."
                }
            ]
        },
        {
            "name": "Elson S. Floyd College of Medicine",
            "source": {
                "label": "WSU Degree Finder, Degrees & Majors",
                "url": "https://degrees.wsu.edu/"
            },
            "majors": [
                {
                    "name": "Nutrition and Exercise Physiology",
                    "degree": null
                },
                {
                    "name": "Speech and Hearing Sciences",
                    "degree": null
                }
            ]
        },
        {
            "name": "Voiland College of Engineering and Architecture",
            "source": {
                "label": "WSU Degree Finder, Degrees & Majors",
                "url": "https://degrees.wsu.edu/"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": null
                },
                {
                    "name": "Bioengineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Construction Management",
                    "degree": null
                },
                {
                    "name": "Cybersecurity",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Interior Design",
                    "degree": null
                },
                {
                    "name": "Landscape Architecture",
                    "degree": null
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Software Engineering",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
